import registeredUser from "@assets/header/menu-selected/icon/registered-user-new.svg";
import AdsContainer from "@components/Container/AdsContainer";
import { PodcastBHCustomEventCategory } from "@components/Gallery/PodcastGallery";
import HorizontalStoryPackage from "@components/HomePageStoryPackages/HorizontalStoryPackage";
import PodcastPackage from "@components/HomePageStoryPackages/MediaPackages/PodcastPackage";
import VideoPackage from "@components/HomePageStoryPackages/MediaPackages/VideoPackage";
import VerticalStoryPackage from "@components/HomePageStoryPackages/VerticalStoryPackage";
import { AdsImu1 } from "@elements/Advertisement/variant/AdsImu";
import { AdsLb2 } from "@elements/Advertisement/variant/AdsLb";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import { UGCWidget } from "@pages/Home/Components/UGCWidget";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";

import WidgetWrapper from "./WidgetWrapper";

export type HomePageNewProps = {
  topStoryQueue: ProcessedArticleData[];
  latestFreeArticle: ProcessedArticleData[];
  latestSgArticle: ProcessedArticleData[];
  latestMaArticle: ProcessedArticleData[];
  kakiJalanArticle: ProcessedArticleData[];
  kakiMakanArticle: ProcessedArticleData[];
  dnaDuniaArticle: ProcessedArticleData[];
  latestGayaArticle: ProcessedArticleData[];
  registeredArticle: ProcessedArticleData[];
  latestDuniaArticle: ProcessedArticleData[];
  adsSectionName: string;
  pageAdTargetValue: PageAdTargetingTypeEnum;
  UGCBanner?: string;
};
export default function HomePageNew({
  topStoryQueue,
  latestFreeArticle,
  latestSgArticle,
  latestMaArticle,
  kakiJalanArticle,
  kakiMakanArticle,
  dnaDuniaArticle,
  latestGayaArticle,
  registeredArticle,
  latestDuniaArticle,
  adsSectionName,
  pageAdTargetValue,
  UGCBanner,
}: HomePageNewProps) {
  return (
    <>
      <WidgetWrapper>
        <VerticalStoryPackage
          firstCardVariant="featured"
          restCardVariant="2md"
          renderItems={topStoryQueue}
          styles={{
            wrapperStyle: "border-t-0",
          }}
        />
      </WidgetWrapper>
      <AdsContainer>
        <AdsLb2
          uniqueSectionName={adsSectionName}
          pageAdTargetType={pageAdTargetValue}
          hasStripeBg={false}
        />
      </AdsContainer>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="featured"
          renderItems={latestFreeArticle}
          styles={{
            wrapperStyle: "border-t-0",
            cardWrapperStyle: "pb-0",
            cardInnerWrapperStyle:
              "flex-col md:grid md:grid-cols-2  xl:flex xl:flex-row gap-[20px] w-full",
            imageWidth: 284,
            imageHeight: 195,
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <VerticalStoryPackage
          firstCardVariant="small"
          restCardVariant="large"
          renderItems={latestSgArticle}
          title="Singapura"
          moreLink={{
            destination: "singapura",
          }}
          styles={{
            wrapperStyle: "border-red-100",
            titleStyle: "text-red-100",
          }}
        />
      </WidgetWrapper>
      <AdsContainer>
        <AdsLb2
          uniqueSectionName={adsSectionName}
          pageAdTargetType={pageAdTargetValue}
          hasStripeBg={false}
          index={1}
        />
      </AdsContainer>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="large"
          renderItems={latestMaArticle}
          title="Malaysia"
          moreLink={{
            destination: "malaysia",
          }}
          styles={{
            wrapperStyle: "border-pink-600",
            titleStyle: "text-pink-600",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="small"
          renderItems={kakiJalanArticle}
          title="Kaki Jalan"
          moreLink={{
            destination: "tags/kaki-jalan",
          }}
          styles={{
            wrapperStyle: "border-blue-400",
            titleStyle: "text-blue-400",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <UGCWidget homeUGCWidgetContent={UGCBanner} />
      </WidgetWrapper>
      <WidgetWrapper>
        <div className="flex flex-col lg:flex-row gap-xs">
          <div className="w-full lg:max-w-[645px] xl:max-w-[860px]">
            <HorizontalStoryPackage
              variant="small"
              renderItems={kakiMakanArticle}
              title="Kaki Makan"
              moreLink={{
                destination: "tags/kaki-makan",
              }}
              styles={{
                wrapperStyle: "border-blue-400",
                titleStyle: "text-blue-400",
              }}
            />
          </div>
          <div className="flex w-full lg:max-w-[320px] justify-center items-center">
            <AdsImu1
              uniqueSectionName={adsSectionName}
              pageAdTargetType={pageAdTargetValue}
            />
          </div>
        </div>
      </WidgetWrapper>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="small"
          renderItems={dnaDuniaArticle}
          title="DNA Dunia Anak"
          moreLink={{
            destination: "tags/dna-dunia-anak",
          }}
          styles={{
            wrapperStyle: "border-blue-350",
            titleStyle: "text-blue-350",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <VerticalStoryPackage
          firstCardVariant="small"
          restCardVariant="large"
          renderItems={latestGayaArticle}
          title="Gaya Hidup"
          moreLink={{
            destination: "gaya-hidup",
          }}
          styles={{
            wrapperStyle: "border-red-600",
            titleStyle: "text-red-600",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="medium"
          renderItems={registeredArticle}
          title="Pengguna Berdaftar"
          moreLink={{
            destination: "registered",
          }}
          styles={{
            wrapperStyle: "border-purple-300",
            titleStyle: "flex gap-xs items-center text-purple-300 pl-xxs",
          }}
          titleIcon={{
            src: registeredUser,
            width: 16,
            height: 16,
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="large"
          renderItems={latestDuniaArticle}
          title="Dunia"
          moreLink={{
            destination: "dunia",
          }}
          styles={{
            wrapperStyle: "border-pink-600",
            titleStyle: "text-pink-600",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <PodcastPackage
          bhCustomEventProps={{
            eventCategory: PodcastBHCustomEventCategory.HOME_PAGE,
            eventAction: "click",
          }}
        />
        <VideoPackage />
      </WidgetWrapper>
    </>
  );
}
